import './homepage.scss';

import * as React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'; 
import { IHistory } from '../../interfaces';
import { Navbar } from '../reusableComponents/Navbar'; 
declare var require: any;
const userIcon = require('../../images/userIcon.png');
const dashboardIcon = require('../../images/dashboardIcon.png');
const fillFormIcon = require('../../images/fillFormIcon.png');
const formSummaryIcon = require('../../images/formSummaryIcon.png');
const factoryIcon = require('../../images/factoryIcon.png');
const spiIcon = require('../../images/spi.png');

export interface IHomePageProps {
    history: IHistory;
}

export class HomePageImpl extends React.PureComponent<IHomePageProps, {}> {

    componentDidMount() {
        document.title = 'Welcome to Argos' as any;
    }

    renderContent = () => {
        const { history } = this.props;
        {/* <div className="header" >
                <div style={setHeaderOpacity} className="set-header-opacity" ></div>
                <div className="header-text" >
                    <h2>We are a <strong>Construction Material Producing</strong> Company</h2>
                    <div className="about-us" >
                        Cementos Argos S.A is a Colombian construction materials producer,
                        with 51% share in the cement market in Colombia,
                         it is the fourth largest cement producer in Latin America,
                         and the only producer of white cement in Colombia. Argos has investments in Panama,
                        Honduras, Haiti and the Dominican Republic.
                    </div>
                    <button className="read-more"  >READ MORE</button>
                </div>
            </div> */}
        return <div className="footer" >
            <div
                title="Click to fill out a form."
                onClick={() => this.props.history.push('/inspections')}
                className="plants-container footer-data"
            >
                <div>
                    <img src={fillFormIcon} />
                </div>
                <div className="label-container" >
                    <span className="footer-brand" >  Inspections</span>
                    <br />
                    {/* <span className="footer-text" >Currently Operational</span> */}
                </div>
            </div>
            <span className="separator" />
            <div
                title="Click to view form summary"
                className="plants-container footer-data"
                onClick={() => this.props.history.push('/summary-reports')}
            >
                <div>
                    <img src={formSummaryIcon} />
                </div>
                <div className="label-container" >
                    <span className="footer-brand" >  Form Summary</span>
                    <br />
                    {/* <span className="footer-text" >Currently Operational</span> */}
                </div>
            </div>
            <span className="separator" />
            <div
                title="Click to go to Argos Dashboard"
                className="user-container footer-data"
                onClick={() => this.props.history.push('/dashboard')}
            >
                <div>
                    <img src={dashboardIcon} />
                </div>
                <div className="label-container" >
                    <span className="footer-brand" >  Dashboard</span>
                    <br />
                    {/* <span className="footer-text" >Using this product</span> */}
                </div>
            </div>
            <span className="separator" />
            <div
                title="Click to manage plants"
                className="plants-container footer-data"
                onClick={() => this.props.history.push('/maintenance')}
            >
                <div>
                    <img src={factoryIcon} />
                </div>
                <div className="label-container" >
                    <span className="footer-brand" >  Maintenance</span>
                    <br />
                    {/* <span className="footer-text" >Currently Operational</span> */}
                </div>
            </div>
            <div
                title="SPI Logo"
                className="spi-footer"
            >
                <div>
                    <img src={spiIcon} />
                </div>
            </div>
        </div>;
    }

    processTrainingButton = () => {  
        window.open(`https://www.enviroconnect.net/`, '_blank');  
    }

    render() {
        return <div className="homepage" >
            <div className="theme" >
                <Navbar />
                <ReactCSSTransitionGroup
                    transitionAppear={true}
                    transitionAppearTimeout={600}
                    transitionEnterTimeout={600}
                    transitionLeaveTimeout={200}
                    transitionName="SlideIn"
                >
                    {this.renderContent()}
                    <div className='redirect-span'><div className="enviro-tab"> <img onClick={() => this.processTrainingButton() } className="enviro-logo" src="
https://www.enviroconnect.net/static/media/logo_.f835507f.png"
alt="Click here to new EnviroConnect portal"/> </div> </div>
                </ReactCSSTransitionGroup>
            </div >;
    </div >;
    }
}

export function mapStateToProps(state) {
    return {
        state
    };
}

export const HomePage = withRouter(connect<{}, {}, IHomePageProps>(mapStateToProps)(HomePageImpl as any));

const setHeaderOpacity: React.CSSProperties = {
    height: '100%',
    width: '100%',
    backgroundColor: 'rgba(0,0,0,0.65)',
    position: 'absolute',
    zIndex: 0
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HomePage/index.tsx